import { Route } from "@angular/router";
import { ToolPermissions } from "@malirang/common";
import { LayoutComponent } from "./layout/layout.component";
import { administrationRoutes } from "./routes/administration.routes";
import { blankRoutes } from "./routes/blank.routes";
import { centerRoutes } from "./routes/center.routes";
import { childRoutes } from "./routes/child.routes";
import { contentRoutes } from "./routes/content.routes";
import { customerRoutes } from "./routes/customer.routes";
import { documentRoutes } from "./routes/document.routes";
import { myPageRoutes } from "./routes/my-page.routes";
import { receiptRoutes } from "./routes/receipt.routes";
import { storeRoutes } from "./routes/store.routes";
import { paymentRoutes } from "./routes/payment.routes";

export const appRoutes: Route[] = [
    {
        path: "",
        pathMatch: "full",
        redirectTo: "schedule",
    },
    ...blankRoutes,
    {
        path: "",
        component: LayoutComponent,
        children: [
            ...paymentRoutes,
            ...storeRoutes,
            ...centerRoutes,
            ...myPageRoutes,
            ...childRoutes,
            ...customerRoutes,
            ...contentRoutes,
            ...receiptRoutes,
            ...documentRoutes,
            ...administrationRoutes,
            {
                path: "",
                redirectTo: "schedule",
                pathMatch: "full",
            },
            {
                path: "withdraw",
                loadComponent: () =>
                    import("./pages/my-page/withdraw/withdraw.page"),
            },
            {
                path: "subscription",
                title: `구독`,
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/subscription/subscription.page"),
                    },
                    {
                        path: ":plan",
                        loadComponent: () =>
                            import(
                                "./pages/subscription/subscription-form/subscription-form.page"
                            ),
                    },
                ],
            },
            {
                path: "schedule",
                title: `일정`,
                loadComponent: () => import("./pages/schedule/schedule.page"),
            },
            {
                path: "guardian",
                children: [
                    {
                        path: "form",
                        loadComponent: () =>
                            import(
                                "./pages/guardian/create-guardian/create-guardian.page"
                            ),
                    },
                ],
            },
            {
                path: "ticket",
                children: [
                    {
                        path: "form",
                        loadComponent: () =>
                            import(
                                "./pages/ticket/create-ticket/create-ticket.page"
                            ),
                    },
                ],
            },
            {
                path: "inspection",
                data: {
                    requiredRoles: [ToolPermissions.TOOL_READ],
                },
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./pages/inspection/inspection.page"),
                    },
                    {
                        path: "form/:childId",
                        loadComponent: () =>
                            import(
                                "./pages/inspection/inspection-form/inspection-form.page"
                            ),
                    },
                    {
                        path: "payment",
                        loadComponent: () =>
                            import(
                                "./pages/inspection/payment-progress/payment-progress.page"
                            ),
                    },
                ],
            },
        ],
    },
];
